import { U21Form, U21Modal } from 'app/shared/u21-ui/components';
import { IconBookmark } from '@u21/tabler-icons';

import { Filter, FilterContext, SavedFilter } from 'app/modules/filters/models';
import { useCreateSavedFilter } from 'app/modules/filters/queries/useCreateSavedFilter';
import { SaveFilterFormContent } from 'app/modules/filters/components/SaveFilterFormContent';

const FORM_ID = 'save-filter-form';

interface FormValues {
  title: string;
  description?: string;
}

interface Props {
  filterContext: FilterContext;
  filters: Filter[];
  onClose: () => void;
  onSaved?: (savedFilter: SavedFilter) => void;
  open: boolean;
}

export const SaveFilterModal = ({
  filterContext,
  filters,
  onClose,
  onSaved,
  open,
}: Props) => {
  const { isPending, mutateAsync: createSavedFilter } = useCreateSavedFilter();

  return (
    <U21Modal
      title="Save Filter"
      titleIcon={<IconBookmark />}
      open={open}
      onClose={onClose}
      actionButtonProps={{
        children: 'Save Filter',
        type: 'submit',
        form: FORM_ID,
        loading: isPending,
      }}
    >
      <U21Form
        id={FORM_ID}
        prompt={false}
        onSubmit={async ({ title, description }: FormValues) => {
          try {
            const saved = await createSavedFilter({
              title,
              description,
              filter_context: filterContext,
              filters,
            });
            onSaved?.(saved);
            onClose();
          } catch {}
        }}
      >
        <SaveFilterFormContent />
      </U21Form>
    </U21Modal>
  );
};
